import { countDaysInDateRange } from '../../../shared/countDaysInDateRange';

export const calculateDayPriceToSinglePayment = (
  singlePaymentPrice: number,
  leasePeriodStart: Date,
  leasePeriodEnd: Date,
) => {
  return Math.round(
    singlePaymentPrice /
      countDaysInDateRange(leasePeriodStart, leasePeriodEnd),
  );
};
